<template>
  <v-container fluid>
    <v-row class="justify-center">
      <v-col
        v-for="(metric, index) in formattedMetrics"
        :key="index"
        cols="12" md="3"
        class="d-flex w-100"
      >
        <v-card class="pa-0 flex-grow-1" elevation="2">
          <v-card-title
            :class="['font-weight-bold', (metric.overdue || metric.ops_overdue || metric.manager_overdue) > 0 ? 'red lighten-5 red--text' : 'green--text light-green lighten-5']">
            {{ metric.title }}
          </v-card-title>
          <v-card-text class="pt-4">
            <v-row v-if="metric.title === 'Jobs'">
              <v-col cols="3" class="px-1">Open</v-col>
              <template v-if="$store.state.auth.profile.role === 'admin'">
                <v-col cols="9" class="px-1 text-center">Overdue</v-col>
                <v-col cols="3" class="display-1 d-flex align-end">{{ metric.open }}</v-col>
                <v-col cols="9" :class="metric.manager_overdue > 0 ? 'display-2 red--text text-center' : 'display-1 text-center'">{{ metric.manager_overdue }}</v-col>
              </template>
              <template v-if="['manager', 'accounts'].includes($store.state.auth.profile.role)">
                <v-col cols="4" class="px-1">Ops Overdue</v-col>
                <v-col cols="5" class="px-1">Manager Overdue</v-col>
                <v-col cols="3" class="display-1 d-flex align-end">{{ metric.open }}</v-col>
                <v-col cols="4" :class="metric.ops_overdue > 0 ? 'display-2 red--text' : 'display-1'">{{ metric.ops_overdue }}</v-col>
                <v-col cols="5" :class="metric.manager_overdue > 0 ? 'display-2 red--text' : 'display-1'">{{ metric.manager_overdue }}</v-col>
              </template>
              <template v-if="$store.state.auth.profile.role === 'operations'">
                <v-col cols="9" class="px-1 text-center">Overdue</v-col>
                <v-col cols="3" class="display-1 d-flex align-end">{{ metric.open }}</v-col>
                <v-col cols="9" :class="metric.ops_overdue > 0 ? 'display-2 red--text text-center' : 'display-1 text-center'">{{ metric.ops_overdue }}</v-col>
              </template>
            </v-row>
            <v-row v-else>
              <v-col cols="6">Open</v-col>
              <v-col cols="6">Overdue</v-col>
              <v-col cols="6" class="display-1 d-flex align-end">{{ metric.open }}</v-col>
              <v-col cols="6" :class="metric.overdue > 0 ? 'display-2 red--text' : 'display-1'">{{ metric.overdue }}</v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-chip-group
          mandatory
          active-class="primary white--text"
          v-model="selectedRole"
        >
          <v-chip
            v-for="role in roles"
            :key="role"
          >
            {{ role }}
          </v-chip>
        </v-chip-group>
      </v-col>
      <v-col cols="12" v-show="selectedRole == 0">
        <OperationsChart :metrics="metrics" />
      </v-col>
      <v-col cols="12" v-show="selectedRole == 1">
        <ReviewChart :reviewData="reviewData" />
      </v-col>
      <v-col cols="12" v-show="selectedRole == 2">
        <AccountsChart :accountsData="accountsData" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ReviewChart from './ReviewChart.vue'
import OperationsChart from './OperationsChart.vue'
import AccountsChart from './AccountsChart.vue'

export default {
  name: 'OpsMetrics',
  props: {
    formattedMetrics: {
      type: Array,
      required: true
    },
    metrics: {
      type: Array,
      required: true
    },
    reviewData: {
      type: Array,
      required: true
    },
    accountsData: {
      type: Array,
      required: true
    }
  },
  components: {
    OperationsChart,
    ReviewChart,
    AccountsChart
  },
  data() {
    return {
      roles: ['operations', 'manager', 'accounts'],
      selectedRole: 'operations'
    }
  }
}
</script>

